<app-header></app-header>

<bit-container>
  <p>{{ "newOrganizationDesc" | i18n }}</p>
  <app-organization-plans></app-organization-plans>
</bit-container>
